import { Route } from '@angular/router';
import { CanDeactivateGuard } from '@pkp-g/core';

export const debtsRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'list',
    pathMatch: 'full',
  },
  {
    path: 'list',
    loadComponent: () => import('./pages').then(p => p.DebtListPage),
    title: 'UIMS - Debts',
  },
  {
    path: 'create',
    loadComponent: () => import('./pages').then(p => p.DebtCreateComponent),
    title: 'UIMS - Debts',
  },
  {
    path: 'details/:id',
    loadComponent: () => import('./pages').then(p => p.DebtDetailsComponent),
    title: 'UIMS - Debt Details',
    canDeactivate: [CanDeactivateGuard],
  },
];
